import { getAuthLogoutUrl } from "@shared/apis/sidekick/api-factories";
import { useAuthStore } from "@store/auth.store";
import { CircularProgress, Typography } from "@mui/material";
import { useEffect, useMemo, useRef } from "react";
import { useNavigate } from "react-router";
import { PageContainer } from "./styles";
import { appEventEmitter } from "@shared/events/app-event-emitter";
import { useAuth } from "@shared/hooks/useAuth";
import { cookieService } from "@shared/services/cookie-service";

export const Logout = () => {
  const logout = useAuthStore((state) => state.logout);
  const { isAuthenticated } = useAuth();
  const firstLoadRef = useRef<boolean>();
  const navigate = useNavigate();

  const logoutURL = useMemo(() => getAuthLogoutUrl(), []);

  useEffect(() => {
    if (firstLoadRef.current) return;
    firstLoadRef.current = true;
    if (!isAuthenticated) {
      navigate("/");
      return;
    }
    appEventEmitter.emit({ eventType: "sidekick-auth-logout" });
    cookieService.deleteAllCookies();
    logout();
    window.location.replace(logoutURL);
  }, [isAuthenticated, logoutURL, logout, navigate]);

  return (
    <PageContainer>
      <Typography>
        <CircularProgress />
      </Typography>
    </PageContainer>
  );
};
